export const MastHeadTitle = 'Veterinary Resources to Help You and Your Pet Families';

// eslint-disable-next-line max-len
export const MastHeadText = 'We feel strongly about sharing information with our veterinary colleagues that will help pets have the peaceful end-of-life experience they deserve. We hope that sharing our tried-and-true practices with veterinary teams will create a dignified, supportive clinic environment that empowers team members to provide the best possible experience for everyone involved.';

export const sliderItems = [
	{
		id: 0,
		state: 'OH',
		city: 'Toledo',
		firstName: 'Dr. Sarah Ryan',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'Our Clinic is pleased and proud to partner with Dr. Ryan. Her compassion and genuine love of animals comes through in everything she does with our clients. Dr. Ryan has the unique ability to make an inherently sad situation warm, comfortable and loving. We absolutely love her!',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Jo Lemanski, Dundee Veterinary Clinic',
	},
	{
		id: 1,
		state: 'VA',
		city: 'Hampton Roads',
		firstName: 'Dr. Elyse Persico',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'I am so thankful for Dr. Persico and her staff and their services. These are people who will hold your hand through the worst day, hug you as a total stranger and give you every tool possible to get you through it and move you to a place where you can look back and finally say, “That was the right thing to do.” ',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Erin Drinkwater',
	},
	{
		id: 2,
		state: 'CA',
		city: 'Silicon Valley',
		firstName: 'Dr. Jeni Goedken',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'I will highly recommend Dr. Jeni Goedken to all pet parents who have to make this hard decision and want to do this in comfort of their own home. Dr. Jeni is an angel who we need in such an emotional hard time, as she will make this difficult time as painless as possible.',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Raj Singh, Aborn Pet Clinic',
	},
	{
		id: 3,
		state: 'OK',
		city: 'Oklahoma City',
		firstName: 'Dr. Lisa Rodin',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'Dr. Rodin, thank you so much for taking such good care of our clients in their time of need. We appreciate the service you’ve been able to provide during this strange time.',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Midtown Vets',
	},
	{
		id: 4,
		state: 'PA',
		city: 'Philadelphia',
		firstName: 'Dr. Brad Bates',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'I’ve heard wonderful things about you from my clients for so many years, and it was good to meet you in person, even under emotional circumstances. I can’t tell you how grateful I am for the work you do, and I’m so grateful to be able to refer my clients to you.',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Natasha Kassell, Holistic House Call Veterinarian',
	},
	{
		id: 5,
		state: 'PA',
		city: 'Philadelphia',
		firstName: 'Dr. Brad Bates',
		lastName: '',
		message: 'Again, thank you for doing what you do.  I know it must be very difficult, but your service is greatly appreciated.',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Caroline Lafferty, Greenfields Veterinary Associates',
	},
	{
		id: 6,
		state: 'TX',
		city: 'Brazos Valley',
		firstName: 'Dr. Colleen Lambo',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'We are so grateful to have Dr. Lambo for after-hours end of life care; she’s an amazing person, kind hearted, compassionate veterinarian. I would not hesitate to contact her for end of life care for my own pets because we all know it’s one of the hardest decisions to make but it can be made so much better with someone who compassionately guides them.',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Brittany Marvel, Chasing Tails Mobile Vet Service',
	},
	{
		id: 7,
		state: 'TX',
		city: 'Brazos Valley',
		firstName: 'Dr. Colleen Lambo',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'Dr. Colleen turned a situation that I had dreaded into a positive experience I will never forget. She made the end of Wilson’s life into such a positive experience for me and my wife.',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Jeff Edwards, Veterinary Pathologist',
	},
	{
		id: 8,
		state: 'OH',
		city: 'Columbus',
		firstName: 'Dr. Nellie Wilbers',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'I continue to recommend you as first choice for euthanasia if I am not available. Every single person who has given feedback says you are terrific. I am grateful to be able to refer even my favorite families to you with confidence.',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Jennifer Taylor Partridge, Housecalls for Dogs & Cats',
	},
	{
		id: 9,
		state: 'OH',
		city: 'Columbus',
		firstName: 'Dr. Nellie Wilbers',
		lastName: '',
		message: 'I think what you have to offer clients is a wonderful and beautiful thing. Thank you for doing what you do!',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dani Ventola, Office Manager, RVT, Stringtown Animal Hospital',
	},
	{
		id: 10,
		state: 'OH',
		city: 'Columbus',
		firstName: 'Dr. Nellie Wilbers',
		lastName: '',
		// eslint-disable-next-line max-len
		message: 'I wanted to thank all at Lap of Love for the way they offer their services in such a compassionate manner. The Blackburns were greatly impressed with the care that was given them and their dog during this stressful time. They specifically wanted to shout out to Dr. Nellie Wilbers for the empathy that she displayed. As a DVM, I also appreciated that you were able to provide such a needed service for clients in distress in their homes. Thanks for what you do. ',
		avatar: '',
		originalAvatar: '',
		extraText: '~ Dr. Dennis Chew',
	},
];
